import Icon, { IconProps } from './Icon';

import LightBulbIcon from '../../../assets/icons/lightbulb-02.svg?react';
import LightBulbGradientIcon from '../../../assets/icons/lightbulb-02-gradient.svg?react';

export interface LightBulbProps extends Omit<IconProps, 'children'> {
  /** Use gradient version (golden gradient) instead of solid color */
  useGradient?: boolean;
}

const LightBulb: React.FC<LightBulbProps> = (props) => {
  const { useGradient = false, ...restProps } = props;
  
  if (useGradient) {
    // Don't pass color/strokeColor to preserve the SVG's native gradient
    const { color, strokeColor, ...gradientProps } = restProps;
    return (
      <Icon {...gradientProps}>
        <LightBulbGradientIcon/>
      </Icon>
    );
  }
  
  return (
    <Icon {...restProps}>
      <LightBulbIcon/>
    </Icon>
  );
};

export default LightBulb;